import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('AssociatedServiceItemService', AssociatedServiceItemService);

  AssociatedServiceItemService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'WindowModalService',
  ];

  function AssociatedServiceItemService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'associated_service_items';

    var service = {
      setAssociatedServiceItems: setAssociatedServiceItems,
      saveAssociatedServiceItem: saveAssociatedServiceItem,
      deleteAssociatedServiceItem: deleteAssociatedServiceItem,
      openAsociatedServiceItemModal: openAsociatedServiceItemModal,
    };

    return service;

    ////////////////

    // Set associated service items
    function setAssociatedServiceItems(associatedServiceItems) {
      var serviceItems = [];

      associatedServiceItems.forEach(function (associatedServiceItem) {
        // associatedServiceItem.service_item.associated_providers.forEach(function () {
        serviceItems.push({
          id: associatedServiceItem.service_item.id,
          name: associatedServiceItem.service_item.name,

          is_default: associatedServiceItem.service_item.is_default,
          status: associatedServiceItem.service_item.status,

          current_costs: associatedServiceItem.service_item.current_costs,
          // });
        });
      });

      return serviceItems;
    }

    function saveAssociatedServiceItem(associatedServiceItem, productType) {
      var url = apiUrl;
      var method = 'post';

      if (associatedServiceItem.id) {
        // update
        method = 'put';
        url += '/' + associatedServiceItem.id;
      }

      url += '/?productType=' + productType;

      return RestResource.request(
        method,
        url,
        { associated_service_item: associatedServiceItem },
        function (response) {
          var msg = !associatedServiceItem.id
            ? 'ASSOCIATED_SERVICE_ITEM_ADDED'
            : 'ASSOCIATED_SERVICE_ITEM_MODIFIED';
          utils._successMsg($translate(msg));

          utils.itemListChanged(response.data.id);

          return {
            status: true,
            response: response.data,
          };
        },
        function (response) {
          utils._errorMsg(response.data.error);

          return {
            status: false,
            response: response.data,
          };
        }
      );
    }

    function deleteAssociatedServiceItem(associatedServiceItemId, productType, successCallback) {
      // index
      let url = apiUrl + '/' + associatedServiceItemId + '?productType=' + productType;

      return RestResource.request(
        'delete',
        url + '&check_if_used=true',
        {},
        function () {
          let params = {
            title: 'SURE_TO_REMOVE_ASSOCIATED_SERVICE_ITEM',
            // body: 'REMOVING_ASSOCIATED_PRODUCT_WARNING',
            successMsg: 'ASSOCIATED_SERVICE_ITEM_REMOVED',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function openAsociatedServiceItemModal(
      associatedServiceItem,
      productType,
      product,
      successCallback
    ) {
      var templateUrl =
        './app/ajs/service-items/associated-service-items/modals/associated-service-item-detail-modal.html';

      var modalParams = {
        title: associatedServiceItem.service_item.name,
        item: associatedServiceItem,
        additionalParams: {
          productType: productType,
          product: product,
        },
      };

      var confirmCallback = function (data) {
        return successCallback(data);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }
  }
})();
